import * as React from "react";
import * as ReactDOM from "react-dom";
export interface AutoResizeTextAreaProps {
    value: string,
    className?: string,
    placeHolder?: string,
    maxLength?: number,
    id?: string,
    onChange(e: React.FormEvent<any>): void
}
export interface AutoResizeTextAreaState {
}

export class AutoResizeTextArea extends React.Component<AutoResizeTextAreaProps, AutoResizeTextAreaState> {
    private ta: HTMLTextAreaElement;

    constructor(props: AutoResizeTextAreaProps) {
        super(props);
        this.state = { };
    }

    private autoSize() {
        if (this.ta) {
            if (this.ta.scrollHeight > this.ta.clientHeight) {
                $(this.ta).css('height', `${this.ta.scrollHeight + 10}px`);
            }
        }
    }

    public componentDidMount() {
        this.autoSize();
    }

    public render(): JSX.Element {
        return (
            <textarea value={this.props.value} className={this.props.className}
                ref={x => this.ta = x}
                id={this.props.id}
                placeholder={this.props.placeHolder}
                maxLength={this.props.maxLength}
                onChange={this.props.onChange}
                onKeyUp={_.debounce(() => this.autoSize(), 100, true) }
                >
            </textarea>);
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/AutoResizeTextAreaControl.tsx